export const GROK_45_OPENROUTER_MODEL_ID = "x-ai/grok-4.5";
export const GROK_45_MODEL_REF = "openrouter/x-ai/grok-4.5";
